var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.user.permissions.indexOf(_vm.permissionsAll.rol_update) >= 0 ||
      _vm.user.person.types_person.id === 3
  )?_c('v-container',[_c('BreadCrumbsVue',{attrs:{"items":_vm.itemsBreadCrumbs}}),_c('FormRol',{attrs:{"actionForm":_vm.actionForm},on:{"sendForm":_vm.sendForm}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }